export default class YearLevel {
    id: number;
    code: string;
    name: string;
    order: number;

    get display() {
        return this.name;
    }

    constructor(data?: Partial<YearLevel>) {
        Object.assign(this, data);
    }
}
